import { defineMessages } from 'react-intl';

export default defineMessages({
    standardizingAddressMessage: {
        id: 'policyview.ea.views.ea-policydetails-details.Standardizing address...',
        defaultMessage: 'Standardizing address...'
    },
    loadingNextPageMessage: {
        id: 'policyview.ea.views.ea-policydetails-details.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    creatingYourSubmissionMessage: {
        id: 'policyview.ea.views.ea-policydetails-details.Creating your submission...',
        defaultMessage: 'Creating your submission...'
    },
    agencyInformation: {
        id: 'policyview.ea.wizard.step.Agency Information',
        defaultMessage: 'Agency Information'
    },
    insuredInformation: {
        id: 'policyview.ea.wizard.step.Policy Details.Insured Information',
        defaultMessage: 'Insured Information'
    },
    Optional: {
        id: 'policyview.ea.views.ea-policydetails-details.optional',
        defaultMessage: 'Optional'
    },
    accountTypeErrorMessage: {
        id: 'policyview.ea.views.ea-policydetails-details.Account type must be a Company or a Person',
        defaultMessage: 'Account type must be a Company or a Person'
    },
    newAccountCreateErrorMessage: {
        id: 'policyview.ea.views.ea-policydetails-details.Could not create the Account',
        defaultMessage: 'Could not create the Account'
    },
    startDate: {
        id: 'policyview.ea.wizard.step.ea-policy-info.Effective Date',
        defaultMessage: 'Effective Date'
    },
    endDate: {
        id: 'policyview.ea.views.ea-policy-info.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    rateAsOfDate: {
        id: 'policyview.ea.views.ea-policy-info.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    loadingSubmissionMessage: {
        id: 'policyview.ea.views.ea-policydetails-details.Submission in progress...',
        defaultMessage: 'Submission in progress...',
    },
    standardizingAddress: {
        id: 'policyview.ea.views.ea-policydetails-details.Standardizing Address...',
        defaultMessage: 'Standardizing Address...',
    },
    riskState: {
        id: 'policyview.ea.views.new-quote.Risk State',
        defaultMessage: 'Risk State'
    },
    originalEffectiveDate: {
        id: 'policyview.ea.wizard.step.ea-policy-info.Original Effective Date',
        defaultMessage: 'Original Effective Date'
    },
    eaPriorAddressTitle: {
        id: 'policyview.ea.views.ea-priorAddress-details.priorAddress',
        defaultMessage: 'Prior Address'
    },
    eaPriorAddressTitleNumber: {
        id: 'policyview.ea.views.ea-priorAddress-details.priorAddress Number:',
        defaultMessage: 'Prior Address:'
    },
    eaPriorAddress: {
        id: 'policyview.ea.quote.Homeowners priorAddress',
        defaultMessage: 'Prior Address'
    },
    removePriorAddressTitle: {
        id: 'policyview.ea.controllers.EHpriorAddressDetailsCtrl.Remove priorAddress?',
        defaultMessage: 'Remove Prior Address?'
    },
    removePriorAddressDescription: {
        id: 'policyview.ea.drivers.remove-priorAddress.message',
        defaultMessage: 'Are you sure you want to remove this Prior Address from the list of Prior Addresses?'
    },
    policyInformation: {
        id: 'policyview.ea.wizard.step.ea-policy-info.Policy Information',
        defaultMessage: 'Policy Information'
    },
    middleName: {
        id: 'policyview.ea.views.ea-policydetails-details.middleName',
        defaultMessage: 'M.I.'
    }
});
